import { Fragment } from "react";
import { parseMarkdownLinks } from "@repo/markdown";

type MarkdownTextProps = {
  text: string;
};

export function MarkdownText({ text }: MarkdownTextProps) {
  const segments = parseMarkdownLinks(text);
  return (
    <>
      {segments.map((segment, i) => {
        if (typeof segment === "string") {
          return <Fragment key={i}>{segment}</Fragment>;
        }
        const isMailto = segment.url.startsWith("mailto:");
        return (
          <a
            key={i}
            className="gitg-description-link"
            href={segment.url}
            {...(isMailto
              ? {}
              : { target: "_blank", rel: "noreferrer noopener" })}
          >
            {segment.label}
          </a>
        );
      })}
    </>
  );
}
